export default __webpack_public_path__ + "static/media/NoRacesMascot.19c67936.png";